import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { sortByText } from "@/helper/array";
import { useContext, useEffect, useMemo } from "react";

import { CityContext } from "@/contexts/city-context-provider";
import { PoliciesStatisticsView } from "./components/PoliciesStatisticsView";
import { StreetStatisticsView } from "./components/StreetStatisticsView";
import { dashboardTabsList } from "./dashboard-tabs";
import { groupCurbZonesData } from "@/modules/street-statistics/components/onstreet";
import { useOnstreetParkingStats } from "@/modules/street-statistics/hooks/use-onstreet-parking-stats";

export const DashboardView = () => {
  const { getParkingStats, curbZones, isLoadingCurbZones } = useOnstreetParkingStats();
  const { currentCity } = useContext(CityContext);

  useEffect(() => {
    if (currentCity?.id) {
      getParkingStats({
        cityId: currentCity.id,
      });
    }
  }, [currentCity, getParkingStats]);

  const { policyStatistic, streetStatistic } = useMemo(() => {
    if (isLoadingCurbZones || curbZones.length === 0) {
      return {
        policyStatistic: { policies: [], curbZones: new Map() },
        streetStatistic: {},
      };
    }
    const { policies, groupedPolicyData, streetData } = groupCurbZonesData(curbZones);
    return {
      policyStatistic: { policies, curbZones: groupedPolicyData },
      streetStatistic: streetData,
    };
  }, [curbZones, isLoadingCurbZones]);

  const listPolicy = sortByText(policyStatistic.policies, "label");

  const isLoading = useMemo(() => {
    return isLoadingCurbZones || !currentCity?.id;
  }, [currentCity?.id, isLoadingCurbZones]);

  return (
    <Tabs defaultValue="policies" className="w-full">
      <TabsList>
        {Object.entries(dashboardTabsList).map((item) => (
          <TabsTrigger value={item[0]} key={item[0]}>
            {item[1]}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="policies">
        <PoliciesStatisticsView
          listPolicy={listPolicy}
          groupedData={policyStatistic.curbZones}
          isLoadingCurbZones={isLoading}
        />
      </TabsContent>
      <TabsContent value="onStreet">
        <StreetStatisticsView groupedData={streetStatistic} isLoadingCurbZones={isLoading} />
      </TabsContent>
    </Tabs>
  );
};
